import { render } from "./Catdetails.vue?vue&type=template&id=0b23d6be&scoped=true"
import script from "./Catdetails.vue?vue&type=script&lang=js"
export * from "./Catdetails.vue?vue&type=script&lang=js"

import "./Catdetails.vue?vue&type=style&index=0&id=0b23d6be&scoped=true&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b23d6be"]])

export default __exports__